import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { addUniqueEntry, isNotEmptyArray } from 'src/app/utilities/utils';

@Component({
  selector: 'app-riskassessment-accor-view',
  templateUrl: './riskassessment-accor-view.component.html',
  styleUrls: ['./riskassessment-accor-view.component.scss'],
})
export class RiskassessmentAccorViewComponent implements OnInit {
  @Input() sectionName: string;
  @Input() subSectionName: string;
  @Input() subSectionSteps: any = [];
  @Input() isCustom: string;
  @Input() roadMapName: string;
  @Input() readonly: boolean;
  hazardCheckLists: any;
  selectedLanguage: string = this.serviceMulti.getDefaultLanguage();
  hazardRatingList = [
    { listName: 'Probability of Occurence', listNameView: this.selectedLanguage == 'en' ? 'Likelihood Of Occurences(LO)' : 'Eintrittswahrscheinlichkeit (LO)', val: 'PO', weightagesList: this.sharedValue.weightagesList, dataChrn: {}, dataIhrn: {},dataRiskChrn: {},dataRiskIhrn: {},  rating: '' },
    { listName: 'Frequency of Exposition', listNameView: this.selectedLanguage == 'en' ? 'Frequency Of Exposure(FE)' : 'Häufigkeit der Gefährdung(FE)', val: 'FE', weightagesList: this.sharedValue.FEweightagesList, dataChrn: {}, dataIhrn: {},dataRiskChrn: {},dataRiskIhrn: {},  rating: '' },
    { listName: 'Degree of Severity', listNameView: this.selectedLanguage == 'en' ? 'Degree Of Possible Harm(DPH)' : 'Schweregrad der Verletzung (DPH)', val: 'SD', weightagesList: this.sharedValue.DPEweightagesList, dataChrn: {}, dataIhrn: {},dataRiskChrn: {},dataRiskIhrn: {},  rating: '' },
    { listName: 'Number of Persons Exposed', listNameView: this.selectedLanguage == 'en' ? 'Number of Persons at Risk(NPE)' : 'Anzahl der gefährdeten Personen (NPE)', val: 'NP', weightagesList: this.sharedValue.NPEweightagesList, dataChrn: {}, dataIhrn: {},dataRiskChrn: {},dataRiskIhrn: {},  rating: '' }];
  constructor( private router: Router, private sharedValue: ShareValuesService,private serviceMulti: LanguageSupportService,public backendService: BackendCallService) { }

  ngOnInit() {
    this.sharedValue.applyHazardRatingLanguage(this.hazardRatingList, this.selectedLanguage);
  }

  toggleAccordion(step, index, list): void {
    list[index - 1] ? list[index - 1].isListItemOpened = false : '';
    list[index + 1] ? list[index + 1].isListItemOpened = false : '';
    step.isListItemOpened = !step.isListItemOpened;
  }

}
